module.exports = __webpack_public_path__ + "static/media/time.c0a125d3.svg";